import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=b4698fde&functional=true&"
var script = {}
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=b4698fde&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports